import React, { Component } from "react";
import { data, projectList } from "../services/data";
import count from "../assets/images/Counter.png";

class Projects extends Component {
  state = {
    data: [],
  };
  componentDidMount() {
    this.setState({
      data,
    });
  }
  trimString(inputString) {
    const maxLength = 200;
    if (inputString.length > maxLength) {
      return inputString.substring(0, maxLength) + "...";
    } else {
      return inputString;
    }
  }
  render() {
    const { data } = this.state;
    const { onHandleProjectDetail } = this.props;
    return (
      <>
        <section
          id="portfolio"
          title="portfolio"
          className="main-section-project"
        >
          <div className="project-main-wrapper">
            <h2 data-aos="fade-down-right" className="title">
              {" "}
              Projects
            </h2>

            <div
              data-aos="fade-down-right"
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginTop: "25px",
              }}
              className="project"
            >
              <ul className="card-list-container updated">
                {projectList.map(
                  ({ id, title, image, detail, liveDemo, sourceCode }) => (
                    <li
                      data-aos="flip-left"
                      data-aos-easing="ease-out-cubic"
                      data-aos-duration="2000"
                      key={id}
                      className="card"
                    >
                      <a className="img-wrapper" href="#2">
                        <img src={image} alt="tonic" />
                      </a>
                      <div className="right-content">
                        <div className="project-title">
                          <h2>{title}</h2>
                        </div>
                        <div className="info">
                          <span>
                            <img
                              src={count}
                              className="counter"
                              alt="counter"
                            />
                          </span>
                          <span>
                            <img
                              src={count}
                              className="counter"
                              alt="counter"
                            />
                          </span>
                        </div>
                        <div className="detail">
                          <p>{detail}</p>
                        </div>
                        <div className="see-project">
                          <a
                            href={liveDemo}
                            className="btn"
                            rel="noreferrer"
                            target="_blank"
                          >
                            See live
                          </a>
                          <a
                            className="btn"
                            href={sourceCode}
                            style={{
                              marginLeft: "20px",
                            }}
                            rel="noreferrer"
                            target="_blank"
                          >
                            Source code
                          </a>
                        </div>
                      </div>
                    </li>
                  )
                )}
              </ul>
            </div>
          </div>
        </section>
        <section
          id="articles"
          title="articles"
          className="main-section-project"
        >
          <div className="project-main-wrapper">
            <h2
              data-aos="fade-down-right"
              className="title"
              style={{
                marginTop: "80px",
              }}
            >
              {" "}
              Articles
            </h2>
            <ul className="card-list-container">
              {data.map(
                ({
                  id,
                  title,
                  image,
                  type,
                  development,
                  year,
                  detail,
                  technologies,
                  fullDesciption,
                  liveDemo,
                  sourceCode,
                }) => (
                  <li
                    data-aos="flip-left"
                    data-aos-easing="ease-out-cubic"
                    data-aos-duration="2000"
                    key={id}
                    className="card"
                  >
                    <a className="img-wrapper" href="#2">
                      <img src={image} alt="tonic" />
                    </a>
                    <div className="right-content">
                      <div className="project-title">
                        <h2>{title}</h2>
                      </div>
                      <div className="info">
                        <span>{type}</span>
                        <span>
                          <img src={count} className="counter" alt="counter" />
                        </span>
                        <span>{development}</span>
                        <span>
                          <img src={count} className="counter" alt="counter" />
                        </span>
                        <span>{year}</span>
                      </div>
                      <div className="detail">
                        <p>{fullDesciption}</p>
                      </div>
                      <div
                        onClick={() =>
                          onHandleProjectDetail({
                            id,
                            title,
                            image,
                            type,
                            development,
                            year,
                            detail,
                            technologies,
                            fullDesciption,
                            liveDemo,
                            sourceCode,
                          })
                        }
                        className="see-project"
                      >
                        <a className="btn" href="#2">
                          See More
                        </a>
                      </div>
                    </div>
                  </li>
                )
              )}
            </ul>
          </div>
        </section>
      </>
    );
  }
}

export default Projects;
